import React from "react";
import PasswordInput from "../common/PasswordInput";

export default function AthletePasswordTab({
  handlePasswordSubmit,
  handlePasswordUpdate,
  passwordRegister,
  passwordSubmitError,
  setPasswordSubmitError,
  passwordErrors,
  getPasswordValues,
  isPasswordFormValid,
  isPasswordUpdating,
}) {
  return (
    <form
      onSubmit={handlePasswordSubmit(handlePasswordUpdate)}
      className="px-6 -mx-6 overflow-y-auto overflow-x-hidden h-[550px]"
    >
      <div
        className="flex items-start sm:items-center p-4 mb-4 text-sm text-fg-brand-strong rounded bg-blue-100"
        role="alert"
      >
        <svg
          className="w-4 h-4 me-2 shrink-0 mt-0.5 sm:mt-0"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M10 11h2v5m-2 0h4m-2.592-8.5h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
        <p>
          <span className="font-medium me-1"> Note:</span> If you change this
          password, the athlete will not be able to log in to the Trackitt
          Portal using their previous credentials. Please ensure the new
          password is shared with the athlete.
        </p>
      </div>

      <div className="flex flex-wrap -mx-6 px-2 overflow-y-auto h-[390px]">
        <div className="w-full md:w-1/2 px-3 mb-2">
          <PasswordInput
            label="New Password"
            name="newPassword"
            register={passwordRegister}
            validation={{
              required: "New password is required.",
              onChange: () => {
                if (passwordSubmitError) setPasswordSubmitError("");
              },
            }}
            errors={passwordErrors}
            placeholder="Enter new password..."
            autoComplete="new-password"
            inputClassName="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 pr-10 leading-tight focus:outline-none focus:bg-white"
            labelClassName="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            containerClassName="relative"
            wrapperClassName="mb-2"
          />
        </div>

        <div className="w-full md:w-1/2 px-3 mb-2">
          <PasswordInput
            label="Confirm New Password"
            name="confirmNewPassword"
            register={passwordRegister}
            validation={{
              required: "Confirm new password is required.",
              validate: (value) =>
                value === getPasswordValues("newPassword") ||
                "New Password and Confirm New Password must match.",
              onChange: () => {
                if (passwordSubmitError) setPasswordSubmitError("");
              },
            }}
            errors={passwordErrors}
            placeholder="Confirm new password..."
            autoComplete="new-password"
            inputClassName="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-2.5 pr-10 leading-tight focus:outline-none focus:bg-white"
            labelClassName="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
            containerClassName="relative"
            wrapperClassName="mb-2"
          />
        </div>
      </div>

      {passwordSubmitError && (
        <p className="text-red-500 text-xs mb-3">{passwordSubmitError}</p>
      )}

      <div className="flex justify-end gap-3 mt-6">
        <button
          type="submit"
          disabled={!isPasswordFormValid || isPasswordUpdating}
          className={`px-4 py-2 text-white rounded-md ${
            !isPasswordFormValid || isPasswordUpdating
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-red-600 hover:bg-red-700"
          }`}
        >
          {isPasswordUpdating ? "Updating..." : "Update Password"}
        </button>
      </div>
    </form>
  );
}
